/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. They use only height and sex, so a muscular person may healthily weigh more than the estimate suggests.`)
};

const es_iw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Solo usan la altura y el sexo, así que una persona musculosa puede pesar de forma saludable más de lo que sugiere la estimación.`)
};

const de_iw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Sie berücksichtigen nur Körpergröße und Geschlecht, sodass eine muskulöse Person gesund mehr wiegen kann, als die Schätzung nahelegt.`)
};

const nl_iw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Ze gebruiken alleen lengte en geslacht, dus iemand met veel spiermassa kan gezond meer wegen dan de schatting suggereert.`)
};

const fr_iw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Elles n'utilisent que la taille et le sexe, donc une personne musclée peut peser sainement plus que ce que l'estimation suggère.`)
};

const it_iw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Usano solo altezza e sesso, quindi una persona muscolosa può pesare sanamente più di quanto suggerisca la stima.`)
};

const pt_br2_iw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Usam apenas altura e sexo, então uma pessoa musculosa pode pesar mais do que a estimativa sugere e ainda assim ser saudável.`)
};

const pt_iw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Usam apenas a altura e o sexo, pelo que uma pessoa musculada pode pesar de forma saudável mais do que a estimativa sugere.`)
};

const ja_iw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。身長と性別のみを使用するため、筋肉質な人は推定値より重くても健康的な場合があります。`)
};

const zh_iw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不考虑。它们只使用身高和性别，因此肌肉发达的人健康体重可能高于估算值。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iw_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iw_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iw_faq_a3", locale)
	if (locale === "en") return en_iw_faq_a3(inputs)
	if (locale === "es") return es_iw_faq_a3(inputs)
	if (locale === "de") return de_iw_faq_a3(inputs)
	if (locale === "nl") return nl_iw_faq_a3(inputs)
	if (locale === "fr") return fr_iw_faq_a3(inputs)
	if (locale === "it") return it_iw_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_iw_faq_a3(inputs)
	if (locale === "pt") return pt_iw_faq_a3(inputs)
	if (locale === "ja") return ja_iw_faq_a3(inputs)
	return zh_iw_faq_a3(inputs)
};